export default __webpack_public_path__ + "static/media/commerce.d911edcb.png";